export default __webpack_public_path__ + "static/media/img-0133-germany-full-face.88b428ef.png";